export default "__VITE_ASSET__1a8b80af__"